<template>
  <b-sidebar
    id="LadderRankSidebar"
    right
    backdrop
    shadow
    no-header
    style="z-index: 9999999"
    width="350px"
  >
    <div class="side-bar-main hidden-scroll-all">
      <div
        v-for="config in list"
        :key="config.label"
        class="card"
        @click="() => scrollToRank(config)"
      >
        <h4>{{ config.label }}</h4>
        <i v-if="config.isLocation" class="icon-Location text-primary"></i>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  data() {
    return {
      splitCount: 50,
    };
  },
  computed: {
    ladderType() {
      return this.$store.state.ladder.selectType;
    },
    stageCount() {
      return this.$store.getters['ladder/getMaxLevelByType'](this.ladderType);
    },
    userStage() {
      return this.$store.getters['ladder/getUserStage'](this.ladderType);
    },
    list() {
      const result = [];
      for (let stage = 1; stage < this.stageCount; stage += this.splitCount) {
        const start = stage;
        const end = Math.min(stage + this.splitCount - 1, this.stageCount);
        result.push({
          label: `${start}-${end}`,
          start: stage,
          end: Math.min(stage + this.splitCount - 1, this.stageCount),
          isLocation: start <= this.userStage && this.userStage <= end,
        });
      }
      return result;
    },
  },
  methods: {
    scrollToRank(config) {
      const scrollToStage = this.$store.state.ladder.scrollToStage;
      if (!scrollToStage) return;
      const {start, end, isLocation} = config;
      const nextStage = this.userStage + 1;
      if (isLocation) {
        scrollToStage(Math.min(nextStage, this.stageCount));
      } else if (nextStage > start) {
        scrollToStage(end);
      } else {
        scrollToStage(start);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.side-bar-main {
  display: flex;
  padding: $spacing-s;
  flex-direction: column;
  align-items: flex-start;
  gap: $spacing-xs;
  flex-shrink: 0;
  background: $bgcontainer;
  height: 100%;
  overflow: scroll;
  .card {
    display: flex;
    min-height: 80px;
    padding: $spacing-s $spacing-m;
    align-self: stretch;
    justify-content: center;
    border-radius: var(--Radius-radius-m, 10px);
    background: #fff;
    border: 4px solid rgba(0, 0, 0, 0);
    box-shadow: 0px 2px 7px 0px rgba(199, 199, 199, 0.4);
    &:hover {
      border: 4px solid var(--Color-Orange, #ffbd5a);
      cursor: pointer;
    }
    i {
      position: absolute;
      right: $spacing-m;
      font-size: 40px;
    }
  }
}
</style>
